function add_inspections_contract(type, id) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/inspections/contracts/add',
        onOpen: function (elm, popup) {
            if (type !== undefined) {
                const input = elm.find('#' + type + '_id');
                input.attr('data-current-value', id);
                input.attr('readonly', 1);
            }

            load_inspection_contract_elements(elm);
            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed();
                if (!document.closeWindow) open_new_object(view_inspection_contract, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function load_inspection_contract_elements(elm) {
    load_for_devices_logic(elm);
    load_inspection_categories_table(elm);

    elm.find('[data-employee-selector]').employeeSelector();
    load_contact_and_company_selectors(elm, { allowEmptyContact: true });
    device_categories_table_toggler(elm);
    load_expires_at_preditor(elm);

    elm.find('[data-address-selector]').addressSelector();
}
function load_for_devices_logic(elm) {
    const $ = jQuery.noConflict();
    const checkbox = elm.find('input[type=checkbox][name=for_devices]');
    const mayEdit = !checkbox.is(':disabled');
    if (!mayEdit) return;

    const allCategories = elm.find('input[type=checkbox][name=for_all_categories]');

    checkbox.change(function() {
        const checked = $(this).is(':checked');
        if (checked) {
            allCategories
                .prop('checked', true)
                .prop('disabled', true)
                .trigger('change');
        } else {
            allCategories.prop('disabled', false);
        }
    });
    checkbox.trigger('change');

}
function load_expires_at_preditor(elm) {
    const beginsAtInput = elm.find('#begins_at');
    const repeatAfterCountInput = elm.find('#repeat_after_0');
    const repeatAfterWhatInput = elm.find('#repeat_after_1');
    const expiresAtInput = elm.find('#expires_at');

    const predictDate = function() {
        const beginsAt = beginsAtInput.val();
        const repeatAfterCount = parseInt(repeatAfterCountInput.val());
        const repeatAfterWhat = repeatAfterWhatInput.val();

        if (!expiresAtInput.hasClass('touched') && beginsAt.length > 0 &&  beginsAt.split('-').length === 3) {
            const date = new Date();
            date.setFullYear(beginsAt.split('-')[2], (parseInt(beginsAt.split('-')[1]) - 1), beginsAt.split('-')[0]);

            switch(repeatAfterWhat) {
                case 'years':
                    date.setFullYear(date.getFullYear() + repeatAfterCount);
                break;
                case 'months':
                    date.setMonth(date.getMonth() + repeatAfterCount);
                break;
                case 'weeks':
                    date.setDate(date.getDate() + (repeatAfterCount * 7));
                break;
            }
            expiresAtInput.val(leadingZero(date.getDate()) + '-' + leadingZero((date.getMonth() + 1)) + '-' + date.getFullYear());
        }
    };
    if (expiresAtInput.val().length === 0) {
        beginsAtInput.change(predictDate);
        repeatAfterCountInput.change(predictDate);
        repeatAfterWhatInput.change(predictDate);
        expiresAtInput.bind('change.registerManualChange', function() {
            expiresAtInput.unbind('change.registerManualChange');
            expiresAtInput.addClass('touched');
        });
    }
}
function load_inspection_categories_table(elm) {
    let type = null;
    let objectId = null;
    let table = elm.find('.categories-table');
    let form = elm.find('form');
    const dummyUrl = table.attr('data-dummy-reloadable-url');


    elm.find('select[name=company_id], select[name=contact_id]').change(function() {
        const companyId = parseInt(elm.find('select[name=company_id]').val());
        const contactId = parseInt(elm.find('select[name=contact_id]').val());

        if (companyId > 0 || contactId > 0) {
            table.show();
            type = companyId > 0 ? 'company' : 'contact';
            objectId = type === 'company' ? companyId : contactId;

            const reloadableUrl = dummyUrl.split('$type').join(type).split('$id').join(objectId);
            table.attr('data-reloadable-url', reloadableUrl);
            table.reloadThisElement();

            let values = {};

            elm.unbind('reload-ajax-popup.inspection-contract').bind('reload-ajax-popup.inspection-contract', function() {
                values = form.serializeJSON();
            });

            elm.unbind('after-reload-popup-before-on-open.inspection-contract').bind('after-reload-popup-before-on-open.inspection-contract', function() {
                table = elm.find('.categories-table');
                form = elm.find('form');

                table.attr('data-reloadable-url', reloadableUrl);
                Object.keys(values).forEach(function(key) {
                    const value = values[key];

                    if (typeof value !== 'object') {
                        const input = form.find(':input[name="' + key + '"]');
                        input.val(value);

                        if (['company_id', 'contact_id'].indexOf(key) >= 0) {
                            input.attr('data-current-value', value);
                            input.trigger('change');
                        }
                    } else {
                        Object.keys(value).forEach(function(subKey) {
                            const input = form.find(':input[name="' + key + '\\[' + subKey + '\\]"]');
                            const val = value[subKey];
                            input.val(val);
                        });
                    }
                });
            });
        } else {
            table.removeAttr('data-reloadable-url');
            table.hide();
        }
    });
}

function view_inspection_contract(id, vars) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/inspections/contracts/view/'+id,
        onOpen: function(elm, popup) {
            load_inspection_contract_elements(elm);
            init_documents_filters(elm);

            elm.off('openTab.devices').on('openTab.devices', async function(event, link) {
                if (link !== 'devices') return;
                elm.isLoading();
                const url = `/inspections/contracts/view/devices/${id}`;
                const htmlString = await $.get(url);
                const html = $(htmlString);
                elm.find('.sub-screen-wrapper#devices').html(html);
                html.find('table').reloadThisElement();
                elm.doneLoading();
                handleFormSubmissions();

            });


            const handleFormSubmissions = () => {
                elm.find('form').each(function() {
                    const form = $(this);
                    if (form[0].hasAjaxFormSubmit) return;
                    form[0].hasAjaxFormSubmit = true;
                    form.ajaxFormSubmit(function(data){
                        $('body').doneLoading();
                        updateObject('inspectionContract', id);
                        if(vars && vars.reload_item) {
                            $(vars.reload_item).reloadThisElement();
                        } else if(vars && vars.callback) {
                            vars.callback(data, elm, popup);
                        }

                        squde_reload_for_flashes();

                        if (document.closeWindow) popup.close();
                    }, function(xhr, status, error) {
                        $('body').doneLoading();
                        squde_flash("Er ging iets mis bij het opslaan.","alert");
                    }.bind([elm,popup]), function() {
                        $('body').isLoading('dark');
                    });

                })
            }
            handleFormSubmissions();
        }
    });
    return false;
}

function delete_inspection_contract(id, name) {

    name = decodeURI(name);
    const $ = jQuery.noConflict();

    custom_delete_with_confirmation("/inspections/contracts/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'inspectioncontract');

    return false;
}

function device_categories_table_toggler(elm) {
    const $ = jQuery.noConflict();
    elm.find('#for_all_categories').change(function() {
        if($(this).is(':checked')) {
            elm.find('.categories-table-wrapper').hide();
        } else {
            elm.find('.categories-table-wrapper').show();
        }
    }).trigger('change');
}

function schedule_inspection() {

    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/inspections/schedule/'+id,
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function make_order_for_contract(id) {
    jQuery.post('/inspections/contracts/makeOrderFor/' + id, function(order) {
        reload_location_if_needed();

        ask('Wat wilt u nu doen?',[
            {
                title: 'Inplannen',
                callback: function() {

                    plan_order(order.id);
                }
            }, {
                title: 'Order bekijken',
                callback: function() {
                    redirect_and_do('/administration/orders', function() {
                        view_order(order.id);
                    });
                }
            }, {
                title: 'Hier blijven',
                buttonClass: 'secondary'
            }
        ]);
    });
    return false;
}

async function show_inspection_contracts_with_products() {
    const $ = jQuery.noConflict();

    // only run when url starts with /inspections/contracts/usage
    if (window.location.pathname.indexOf('/inspections/contracts/usage') !== 0) {
        return;
    }

    const improveTableStyle = (table) => {
        table.css({
            'width': '100%',
            marginBottom: 0
        });
        //thead is sticky
        table.find('thead').css({
            'position': 'sticky',
            'top': 0,
            'background': '#fff',
            'z-index': 1,
        });
    };

    $('body').isLoading();

    const fetchData = async () => {
        const fromInput = $('#from');
        const toInput = $('#to');

        const url = '/api/inspections/contracts/fetchUsage';
        const data = {
        };
        const from = moment(fromInput.val(), 'DD-MM-YYYY');
        const to = moment(toInput.val(), 'DD-MM-YYYY');

        if (from.isValid()) {
            data.from = from.format('YYYY-MM-DD');
        }
        if (to.isValid()) {
            data.to = to.format('YYYY-MM-DD');
        }
        if (data.from === undefined || data.to === undefined) {
            return [];
        }
        setCookie('inspection_contracts_usage_range', [fromInput.val(), toInput.val()], 7);

        return await $.get(url, data);
    }

    // Replace the .scrollable-table with 2 divs, leftSide and rightSide. Both divs are scrollable
    // Put the table in the leftSide
    const table = $('.scrollable-table').clone();
    const leftSide = $('<div class="leftSide"></div>');
    leftSide.append(table);

    const thead = table.find('thead');
    const tbody = table.find('tbody');

    const rightSide = $('<div class="rightSide"></div>');
    const sidesWrapper = $('<div class="sidesWrapper"></div>');
    sidesWrapper.append(leftSide);
    sidesWrapper.append(rightSide);
    $('.scrollable-table:nth-child(1)').replaceWith(sidesWrapper);

    (() => {
        // Create a filters div above the sidesWrapper
        const filters = $('<div class="filters"></div>');
        filters.css({
            'display': 'flex',
            'flex-direction': 'row',
            'justify-content': 'flex-end',
            'align-items': 'center',
            'padding': '0 10px',
            'background': '#fff',
        })
        sidesWrapper.before(filters);

        const addFilter = (input, label) => {
            const filter = $('<div class="filter"></div>');
            filter.append(label);
            filter.append(input);
            input.change(async function() {
                $('body').isLoading();
                await reloadData();
                $('body').doneLoading();
            })
            filters.append(filter);
        }

        // Add a datepicker
        const fromInput = $('<input type="text" id="from" placeholder="Selecteer een datum" onclick="init_and_open_datepicker(this)"  />');
        const fromLabel = $('<label for="from">Van</label>');
        addFilter(fromInput, fromLabel);

        const toInput = $('<input type="text" id="to" placeholder="Selecteer een datum" onclick="init_and_open_datepicker(this)"  />');
        const toLabel = $('<label for="to">Tot</label>');
        addFilter(toInput, toLabel);

        const defaultRange = getCookie('inspection_contracts_usage_range');
        if (defaultRange) {
            const [from, to] = defaultRange;
            fromInput.val(from);
            toInput.val(to);
        }
    })();

    // Set the css
    $('.window-wrapper').css({
        marginBottom: 0,
    })
    sidesWrapper.css({
        'display': 'flex',
        'flex-direction': 'row',
        'height': 'calc(100vh - 25px - ' + sidesWrapper.offset().top + 'px)',
    });
    leftSide.css({
        'overflow-y': 'auto',
        'overflow-x': 'hidden',
        'background': '#fff',
        padding: '5px',
        flex: 1,
    });
    rightSide.css({
        'overflow-y': 'auto',
        'overflow-x': 'hidden',
        'background': '#fff',
        padding: '5px',
        flex: 1,
    });
    improveTableStyle(table);

    // Columns to draw
    const columns = {
        name: {
            title: 'Naam',
            render: (row) => {
                const a = $('<a />').text(row.name);
                a.click(function (e) {
                    e.preventDefault();
                    view_inspection_contract(row.id);
                })
                return a;
            },
            sortable: true
        },
        customer: {
            title: 'Klant',
            render: (row) => {
                const a = $('<a />').text(row.customer.name);
                a.click(function (e) {
                    e.preventDefault();
                    if (Object.keys(row.customer).indexOf('coc_no') !== -1) {
                        view_company(row.customer.id);
                    } else {
                        view_contact(row.customer.id);
                    }
                })
                return a;
            },
            sortable: true,
            sort: (data, direction) => {
                return _.orderBy(data, 'customer.name', direction);
            }
        },
        expires_at: {
            title: 'Vervaldatum',
            render: (row) => {
                return moment(row.expires_at).format('DD-MM-YYYY');
            },
            sortable: true,
            sort: (data, direction) => {
                return _.orderBy(data, 'expires_at', direction);
            }
        },
        planned: {
            title: 'Gepland',
            render: (row) => {
                if (row.planned) {
                    return '<span class="visual-icon-tick green" style="margin-right: 5px;"></span>';
                } else {
                    return '<span class="visual-icon-cross" style="margin-right: 5px;"></span>';
                }
            }
        },
        product: {
            title: 'Product',
            render: (row) => {
                const a = $('<a />').text(row.product.name);
                a.click(function (e) {
                    e.preventDefault();
                    view_product(row.product.id);
                });
                return a;
            },
            sortable: true,
            sort: (data, direction) => {
                return _.orderBy(data, 'product.name', direction);
            }
        },
        amount: {
            title: 'Aantal',
            render: (row) => {
                return row.product.pivot.amount;
            },
            sortable: true,
            sort: (data, direction) => {
                return _.orderBy(data, 'product.pivot.amount', direction);
            }
        }
    };

    const headingRow = $('<tr>');
    thead.html(headingRow);
    Object.keys(columns).forEach((key) => {
        const column = columns[key];
        const th = $('<th>').text(column.title);
        headingRow.append(th);
    });



    const reloadData = async () => {
        const data = await fetchData();

        drawTable(table, columns, data);


        // Create a totals div on the right side showing the list of unique products and their amounts
        const totalsDiv = $('<div class="totals"></div>');
        rightSide.html(totalsDiv);


        rightSide.prepend('<h4>Benodigdheden voor deze contracten</h4>');

        const totalsColumns = {
            name: {
                title: 'Naam',
                render: (row) => {
                    const a = $('<a />').text(row.name);
                    a.click(function (e) {
                        e.preventDefault();
                        view_product(row.id);
                    });
                    return a;
                },
                sortable: true,
            },
            amount: {
                title: 'Aantal',
                sortable: true,
            },
        }

        const totalsTable = $('<table></table>').addClass('totalsTable').addClass('scrollable-table');
        totalsDiv.append(totalsTable);

        const products = data.map((row) => {
            return row.product;
        });
        const uniqueProducts = _.sortBy(_.uniqBy(products, 'id'), 'name').map((product) => {
            product.amount = _.sumBy(products.filter((p) => {
                return p.id === product.id;
            }), 'pivot.amount');
            return product;
        });

        drawTable(totalsTable, totalsColumns, uniqueProducts);
    }

    const drawTable = (table, columns, data, orderBy = null) => {
        // Get thead or create it
        let thead = table.find('thead');
        if (thead.length === 0) {
            thead = $('<thead>');
            const tr = $('<tr>');
            thead.append(tr);
            table.append(thead);
        }

        // Draw head
        thead.find('tr').empty();
        Object.keys(columns).forEach((key) => {
            const column = columns[key];
            const th = $('<th>');
            if (column.sortable) {
                const a = $('<a href="#">').text(column.title);
                a.click(function (e) {
                    e.preventDefault();
                    let direction = 'asc';
                    if (orderBy && orderBy[0] === key && orderBy[1] === 'asc') {
                        direction = 'desc';
                    }
                    drawTable(table, columns, data, [key, direction]);
                });
                th.append(a);
            } else {
                th.text(column.title);
            }
            thead.find('tr').append(th);
        });

        // Get tbody or create it
        let tbody = table.find('tbody');
        if (tbody.length === 0) {
            tbody = $('<tbody>');
            table.append(tbody);
        }
        table.find('tbody:nth-child(3)').remove()

        improveTableStyle(table);

        // Remove all body
        tbody.find('tr').remove();

        if (orderBy) {
            const [key, direction] = orderBy;
            const column = columns[key];
            if (column.sort) {
                data = column.sort(data, direction);
            } else {
                data = _.orderBy(data, key, direction);
            }
        }

        // Fill the table
        data.forEach((row) => {
            const tr = $('<tr>');
            Object.keys(columns).forEach((key) => {
                const column = columns[key];
                const td = $('<td>');
                let value = row[key];

                if (column.render) {
                    value = column.render(row);
                }

                td.html(value);
                tr.append(td);
            });
            tbody.append(tr);
        });
    }

    await reloadData();


    leftSide.prepend('<h4>Contracten</h4>');

    $('body').doneLoading();

}
jQuery(document).ready(function() {
    show_inspection_contracts_with_products();
})


function attach_contact_to_inspection_contract(sender, inspection_contract_id) {
    const $ = jQuery.noConflict();
    const contact_id = $(sender).serializeJSON().contact_id;

    $.post(`/inspections/contracts/attachContactToInspectionContract/${inspection_contract_id}/${contact_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        });
    return false;
}

function detach_contact_from_inspection_contract(inspection_contract_id, contact_id) {
    const $ = jQuery.noConflict();
    $.post(`/inspections/contracts/detachContactFromInspectionContract/${inspection_contract_id}/${contact_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        });
    return false;
}
